<template>
  <div class="layout_contents">
    <dl class="dl-info">
      <dt>팬스타 면세점</dt>
      <dd>
        팬스타크루즈는 고객님께 더 많은 혜택과 편의를 제공하기 위해 오프라인 선내 면세점과 온라인 면세점을 운영하고
        있습니다.
      </dd>
    </dl>
    <hr class="hr-line" />
    <dl class="dl-info">
      <dt>이용대상</dt>
      <dd>팬스타 국제선 선박을 이용하시는 모든 승객</dd>
    </dl>
    <hr class="hr-line" />
    <dl class="dl-info">
      <dt>팬스타 선내 및 온라인 면세점 이용 안내</dt>
      <dd>
        <p class="label-number">01 결제 안내</p>

        <p class="label-part">선내면세점</p>
        <ul class="list-cir">
          <li>현금(KRW / JPY / USD), 신용카드 사용이 가능합니다.</li>
          <li>외화 결제 시, KEB하나은행의 거래 당일 최초 매매기준율이 적용됩니다.</li>
        </ul>
        <p class="label-part">온라인 면세점 (https://pnuezmall.co.kr/)</p>
        <ul class="list-cir">
          <li>카드 결제 및 간편결제 이용이 가능합니다.</li>
        </ul>
        <hr class="hr-line" />
        <p class="label-number">02 이용 안내</p>
        <ul class="list-cir">
          <li><strong>출국편과 귀국편 모두 면세점 이용</strong>이 가능합니다.</li>
          <li>온라인 면세점에서 <strong>사전 구매</strong>한 상품은 승선 후 선내 면세점에서 수령 가능합니다.</li>
          <li>
            <strong>귀국편 승선일을 상품 수령일로 지정</strong>하시면 여행 중 면세품을 휴대할 필요 없이 더욱 편한 여행이
            가능합니다.
          </li>
          <li>
            온라인 면세점은
            <strong>승선일 기준 1개월 전부터, 승선 1일 전까지 구매 가능</strong>합니다.
          </li>
          <li>
            단, 일부 품목은 상품 준비를 위해 <strong>승선 3일 전</strong>(영업일 기준)까지 구매하셔야 하며, 재고상황에
            따라 판매가 취소될 수도 있습니다.
          </li>
        </ul>
        <p class="label-part">온라인면세점 구매 방법</p>

        <ul class="list-cir">
          <li>STEP1. 팬스타 온라인 면세점에 접속 후 이름, 이메일, 비밀번호 등 간단한 정보로 회원 가입</li>
          <li>STEP2. 로그인 시 아이디와 비밀번호 입력 또는 SNS</li>
          <li>STEP3. 상품의 가격 및 상세 정보를 확인한 후, 상품을 장바구니에 담거나 즉시 주문</li>
          <li>STEP4. 결제 진행 (신용카드 및 간편결제 가능), 상품 수령 선박, 수령일, 수령자 정보 입력</li>
          <li>
            STEP5. 구매 상품은 선박 승선 후 <strong>선내 면세점</strong>에서 <strong>신분증 제시</strong> 및 관계자가
            제공하는 <strong>인도 확인서 서명</strong> 후 수령
          </li>
        </ul>
        <p class="label-part">상품 수령 시 유의사항</p>

        <ul class="list-cir">
          <li>
            구매 상품과 실물을 즉시 확인하시고, 이상 발생 시 즉시 상품 인도자에게 알려 조치를 요청하시기 바랍니다.
          </li>
        </ul>

        <hr class="hr-line" />

        <p class="label-number">03 환불 및 수령일 변경 안내</p>
        <p class="label-part">선내 면세품 환불 및 교환</p>
        <ul class="list-cir">
          <li>
            포장을 개봉하지 않은 상품에 한하며, 구매하신 항차 운항 종료 전
            <strong>영수증 지참 시</strong> 가능합니다.
          </li>
          <li>개봉 상품은 반품이 불가합니다.</li>
        </ul>
        <p class="label-part">온라인 면세점 구매 시</p>

        <ul class="list-cir">
          <li>
            <strong>항차 결항 또는 면세품 미수령</strong> 시 예약이 <strong>자동으로 취소되지 않으니</strong>, 취소 및
            수령일 변경은 반드시 <strong>팬스타 면세점 고객센터</strong>를 통해 처리해 주시기 바랍니다. (051-240-8826 /
            https://www.panstarcruise.com/support/qna)
          </li>
          <li>
            이벤트 상품의 수령일 변경은 <strong>최대 1개월 내</strong>로 제한되며, 이벤트 및 상품 특성에 따라 다를 수
            있습니다.
          </li>
        </ul>

        <hr class="hr-line" />
        <p class="label-number">04 면세 한도 안내</p>
        <ul class="list-cir">
          <li>구매에 별도의 한도액은 없습니다. 단, 국가(한국, 일본)별 면세 허용량 준수 필요</li>
          <li>
            주류 및 담배는 만 19세 이상만 구매 가능하며, 면세 혜택이 제공됩니다. (만 19세 미만은 주류, 담배 면세 불가)
          </li>
          <li>국가별 면세 한도 초과 시, 해당 국가 세관에 반드시 신고해야 합니다.</li>
          <li>
            면세 한도는 다음 품목들을 포함합니다.<br />
            외국 및 국내에서 구매한 물품(선물 포함)<br />
            국내 면세점에서 구매 후 재반입하는 물품
          </li>
        </ul>

        <p class="label-part">대한민국</p>
        <div class="wrap-table">
          <table class="table-form2">
            <tbody>
              <tr>
                <th>휴대품</th>
                <td colspan="2">$800<br />(해외에서 취득한 물품 포함)</td>
              </tr>
            </tbody>
          </table>
          <p class="txt-part">별도</p>

          <table class="table-form2">
            <tbody>
              <tr>
                <th>주류</th>
                <td>2병</td>
                <td>2L, USD 400이하</td>
              </tr>
              <tr>
                <th>담배</th>
                <td>
                  담배 200개비, 전자담배 니코틴용액 20ml<br />
                  (니코틴함량 1%미만)
                </td>
                <td></td>
              </tr>
              <tr>
                <th>향수</th>
                <td>100ml</td>
                <td>향수 종류 구별 없음</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p class="label-part">일본</p>
        <div class="wrap-table">
          <table class="table-form2">
            <tbody>
              <tr>
                <th>휴대품</th>
                <td colspan="2">JPY 200,000<br />(해외에서 취득한 물품 포함)</td>
              </tr>
            </tbody>
          </table>
          <p class="txt-part">별도</p>

          <table class="table-form2">
            <tbody>
              <tr>
                <th>주류</th>
                <td>3병</td>
                <td>1병당 760ml</td>
              </tr>
              <tr>
                <th>담배</th>
                <td>담배 200개비<br />가열식담배 개별포장 10개<br />그 외의 경우 250g</td>
                <td>
                  '아이코스'(IQOS)의 경우: 200개<br />'글로우'(glo)의 경우: 200개<br />'플룸테크'(Ploom TECH)의 경우:
                  50개
                </td>
              </tr>
              <tr>
                <th>향수</th>
                <td>2온스</td>
                <td>
                  1온스는 약 28ml<br />(오드코오롱,
                  <span class="br">오드뚜왈렛은 포함되지 않습니다.)</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </dd>
    </dl>

    <hr class="hr-line" />
    <div class="ui-buttons">
      <div class="btn" @click="goToDutyFree">면세점 바로가기</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DutyFreeGuide',
  methods: {
    goToDutyFree() {
      window.open('https://pnuezmall.co.kr/');
    },
  },
};
</script>

<style scoped>
.layout_contents {
  width: 100%;
  max-width: 1384px;
  padding: 0 16px;
  margin: 0 auto;
}
.list-cir + .label-part {
  margin-top: 40px;
}
.list-cir li strong {
  font-weight: 500;
  color: #f18d00;
}
.label-part {
  font-size: 22px;
  font-weight: 600;
  line-height: 33px;
  margin-bottom: 20px;
  color: #304da7;
}
.dl-info dt {
  font-size: 34px;
  font-weight: bold;
  padding-bottom: 16px;
  line-height: 36px;
}
.dl-info dd .label-number {
  margin-top: 44px;
}
.dl-info dd .label-number + .list-cir {
  margin-top: -20px;
}
.dl-info dd {
  font-size: 20px;
  font-weight: 500;
  color: #858b92;
  line-height: 24px;
}
.dl-info dd .label-number {
  font-size: 28px;
  font-weight: 600;
  color: #304da7;
  padding-bottom: 40px;
}
.dl-info dd ul.list-cir {
}
.dl-info dd ul.list-cir li {
  margin-left: 20px;
  padding-left: 30px;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  position: Relative;
}
.dl-info dd ul.list-cir li + li {
  margin-top: 8px;
}
.dl-info dd ul.list-cir li:before {
  display: inline-block;
  position: absolute;
  top: 10px;
  left: 10px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #686d72;
  content: '';
}

.hr-line {
  margin: 60px 0;
  border: none;
  border-bottom: 1px solid #dddfe2;
}
.wrap-table {
  overflow: auto;
}
.table-form2 {
  min-width: 611px;
}
.wrap-table + .label-part {
  margin-top: 40px;
}
.table-form2 tbody tr th {
  font-size: 20px;
  min-width: 60px;
  line-height: 140%;
  text-align: center;
  font-weight: 600;
  background: #f5f7f9;
  border: 1px solid #dddfe2;
  padding: 15px 0;
  width: 450px;
}
.table-form2 tbody tr td {
  font-size: 16px;
  padding: 15px 0;
  color: #686d72;
  text-align: center;
  border: 1px solid #dddfe2;
}
.txt-part {
  font-size: 20px;
  text-align: center;
  padding: 16px 0;
  color: #686d72;
  line-height: 140%;
}
.ui-buttons {
  text-align: center;
  padding-bottom: 90px;
}
.btn {
  display: inline-block;
  border-radius: 5px;
  background-color: #446ceb;
  width: 160px;
  line-height: 50px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
}
@media (max-width: 767px) {
  .layout_contents {
    width: 100%;
  }
  .dl-info dt {
    font-size: 24px;
    line-height: 36px;
    padding-bottom: 12px;
  }
  .dl-info dd {
    font-size: 16px;
    line-height: 140%;
    font-weight: normal;
  }
  .hr-line {
    margin: 24px 0;
  }
  .dl-info dd .label-number {
    margin: 12px 0 0 0;
    padding-bottom: 16px;
    font-size: 22px;
    line-height: 24px;
  }
  .label-part {
    margin-bottom: 12px;
    line-height: 24px;
    font-size: 18px;
  }
  .dl-info dd ul.list-cir li {
    font-size: 16px;
    font-weight: normal;
    line-height: 140%;
    margin-left: 0;
    padding-left: 25px;
  }
  .dl-info dd ul.list-cir li:before {
    width: 3px;
    height: 3px;
  }
  .dl-info dd ul.list-cir li + li {
    margin-top: 4px;
  }
  .list-cir + .label-part {
    margin-top: 16px;
  }
  .dl-info dd .label-number + .list-cir {
    margin: 0;
  }
  .table-form2 tbody tr th {
    width: 60px;
    font-size: 16px;
    line-height: 120%;
    padding: 15px 0;
  }
  .table-form2 tbody tr td {
    width: 276px;
  }
  .table-form2 tbody tr td .br {
    display: block;
  }
  .txt-part {
    width: 611px;
    font-size: 16px;
    padding: 15px 0;
  }

  .wrap-table + .label-part {
    margin-top: 16px;
  }
  .ui-buttons {
    text-align: center;
    padding-bottom: 48px;
  }
  .btn {
    border-radius: 5px;
    background-color: #446ceb;
    width: 100%;
    line-height: 50px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
